import baseColor from "./base";
import baseColorDarkmode from "./base-darkmode";

export default Object.assign({}, baseColor, baseColorDarkmode);
